
import { defineComponent, PropType } from 'vue'
import MagazineCard from '@/components/block/MagazineCard.vue'
import { MagazineCardProps } from '@/types/MagazineSpecial'
export default defineComponent({
  name: 'MagazineCardList',
  props: {
    items: {
      type: Array as PropType<MagazineCardProps[]>,
      default: () => []
    },
    borderTop: Boolean,
    borderBottom: Boolean,
    articleIndex: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MagazineCard
  }
})
